import React, { useContext } from "react";
import Sound from "react-sound";
import Context from "../../../Context";

export default function Sounds() {
  const cx = useContext(Context);
  const buzz = cx.notifier.buzz || {};
  const soundMap = {
    task: "/assets/media/sound/notify_task.mp3",
    notice: "/assets/media/sound/notify_task.mp3",
  };
  let playSounds = [];
  for (let key in buzz) {
    if (buzz[key] === true && soundMap[key]) {
      playSounds.push(soundMap[key]);
    }
  }

  return (
    <>
      {playSounds.length > 0 ? (
        <>
          {playSounds.map((soundFile) => (
            <Sound
              key={soundFile}
              url={soundFile}
              playStatus={Sound.status.PLAYING}
            />
          ))}
        </>
      ) : null}
    </>
  );
}
